module.exports = {"API_URL":"http://pipe-digital-api.local.ro:8090/v1"}


//////////////////
// WEBPACK FOOTER
// ./static/config.json
// module id = IuJc
// module chunks = 1